export const visit = (vm, at) => {
at({ "no-no": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Ny melding" } } } });
};